webpackJsonp([268608278405510],{

/***/ "./src/assets/labcoat.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/labcoat.543bbff8.png";

/***/ }),

/***/ "./src/components/atoms/SocialTags.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.MetaTags = undefined;
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _labcoat = __webpack_require__("./src/assets/labcoat.png");
	
	var _labcoat2 = _interopRequireDefault(_labcoat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetaTags = exports.MetaTags = function MetaTags(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      _ref$src = _ref.src,
	      src = _ref$src === undefined ? _labcoat2.default : _ref$src;
	  return [_react2.default.createElement("meta", { key: "title", property: "og:title", content: title }), _react2.default.createElement("meta", { key: "title", property: "og:description", content: description }), _react2.default.createElement("meta", { property: "og:image", content: src }), _react2.default.createElement("meta", { name: "twitter:title", content: title }), _react2.default.createElement("meta", { name: "twitter:description", content: description }), _react2.default.createElement("meta", { name: "twitter:image", content: src }), _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" })];
	};

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/vercel/path0/node_modules/babel-preset-react-app/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/react-hot-loader/babel.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/careers/post.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["padding: 0;"], ["padding: 0;"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding-top: 2.5rem;\n  padding-bottom: .625rem;\n  font-weight: 500;\n"], ["\n  padding-top: 2.5rem;\n  padding-bottom: .625rem;\n  font-weight: 500;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	var _Post = __webpack_require__("./src/components/Post.js");
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/src/react-markdown.js");
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _Background = __webpack_require__("./src/components/blocks/Background.js");
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _SocialTags = __webpack_require__("./src/components/atoms/SocialTags.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ListingBody = _Post.PostBody.extend(_templateObject);
	
	var Label = _typography.H5.extend(_templateObject2);
	
	exports.default = function (props) {
	  var jobListing = props.pathContext;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: "Contraline News",
	        meta: [{ name: "Contraline", content: jobListing.title }]
	      },
	      _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default }),
	      _react2.default.createElement(_SocialTags.MetaTags, {
	        title: jobListing.title,
	        description: jobListing.description && jobListing.description.description
	      })
	    ),
	    _react2.default.createElement(_NavBar2.default, { color: "dark", background: "white" }),
	    _react2.default.createElement(
	      _Background2.default,
	      { color: "white", fixed: true },
	      _react2.default.createElement(
	        _Section2.default,
	        { noBorder: true, fixed: true, vPad: false },
	        _react2.default.createElement(
	          _Pad2.default,
	          { h: 2, v: 2 },
	          _react2.default.createElement(
	            Label,
	            null,
	            "Position"
	          ),
	          _react2.default.createElement(
	            _typography.H3,
	            { serif: true },
	            jobListing.title
	          ),
	          _react2.default.createElement(
	            Label,
	            null,
	            "About Contraline"
	          ),
	          _react2.default.createElement(
	            ListingBody,
	            { style: { paddingLeft: 0 } },
	            _react2.default.createElement(_reactMarkdown2.default, {
	              source: jobListing.aboutContraline && jobListing.aboutContraline.aboutContraline
	            })
	          ),
	          _react2.default.createElement(
	            Label,
	            null,
	            "Job description"
	          ),
	          _react2.default.createElement(
	            ListingBody,
	            { style: { paddingLeft: 0 } },
	            _react2.default.createElement(_reactMarkdown2.default, {
	              source: jobListing.description && jobListing.description.description
	            })
	          ),
	          _react2.default.createElement(
	            Label,
	            null,
	            "What you'll do"
	          ),
	          _react2.default.createElement(
	            ListingBody,
	            { style: { paddingLeft: 0 } },
	            _react2.default.createElement(_reactMarkdown2.default, {
	              source: jobListing.responsibilities && jobListing.responsibilities.responsibilities
	            })
	          ),
	          _react2.default.createElement(
	            Label,
	            null,
	            "What you'll need"
	          ),
	          _react2.default.createElement(
	            ListingBody,
	            { style: { paddingLeft: 0 } },
	            _react2.default.createElement(_reactMarkdown2.default, {
	              source: jobListing.criteria && jobListing.criteria.criteria
	            })
	          )
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 2 })
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-careers-post-js-7821f6deb5c4dc3e5cfb.js